import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { normalizedData } from "@utils";
import Seo from "@components/seo";
import Layout from "@layout";
import Header from "@layout/header/layout-01";
import Footer from "@layout/footer/layout-01";
import PageHeader from "@containers/page-header/layout-01";
import SolutionArea from "@containers/solution/layout-01";
import FunFactArea from "@containers/funfact/layout-02";
import { Row, Col } from "@ui/wrapper";
import CountUp from "react-countup";

const AboutPage = ({ location, data }) => {
    const content = normalizedData(data?.page.content || []);
    const globalContent = normalizedData(data?.allGeneral.nodes || []);
    return (
        <Layout location={location}>
            <Seo title="About Us" />
            <Header
                data={{
                    ...globalContent["header"],
                    ...globalContent["menu"],
                }}
            />
            <main className="site-wrapper-reveal">
                <PageHeader data={content["page-header-section"]} />
                <SolutionArea data={content["solution-section"]} />
                {/* <FunFactArea data={content["funfact-section"]} /> */}
                <div
                    style={{
                        width: "100%",
                        height: "216px",
                        background: "#246bd5",
                        // marginTop: "10px",
                        padding: "0 185.33px",
                        paddingTop: "59px",
                        paddingBottom: "29px",
                        textAlign: "center",
                    }}
                >
                    <Row>
                        <Col lg={{ span: 4 }} xs={{ span: 12 }}>
                            <div
                                style={{
                                    alignContent: "center",
                                    color: "#fff",
                                    fontSize: "56px",
                                    fontWeight: "550",
                                }}
                            >
                                70
                                <span
                                    style={{
                                        fontSize: "40px",
                                        fontWeight: "550",
                                    }}
                                >
                                    +
                                </span>
                            </div>
                            <h6
                                style={{
                                    color: "#ffffffb3",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    letterSpacing: "2px",
                                    textAlign: "center",
                                }}
                            >
                                员工数
                            </h6>
                        </Col>
                        <Col lg={{ span: 4 }}>
                            <div
                                style={{
                                    alignContent: "center",
                                    color: "#fff",
                                    fontSize: "56px",
                                    fontWeight: "550",
                                }}
                            >
                                80
                                <span
                                    style={{
                                        fontSize: "40px",
                                        fontWeight: "550",
                                    }}
                                >
                                    %
                                </span>
                            </div>

                            <h6
                                style={{
                                    color: "#ffffffb3",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    letterSpacing: "2px",
                                    textAlign: "center",
                                }}
                            >
                                研发人才占比
                            </h6>
                        </Col>
                        <Col lg={{ span: 4 }}>
                            <div
                                style={{
                                    alignContent: "center",
                                    color: "#fff",
                                    fontSize: "56px",
                                    fontWeight: "550",
                                }}
                            >
                                10
                                <span
                                    style={{
                                        fontSize: "40px",
                                        fontWeight: "550",
                                    }}
                                >
                                    年+
                                </span>
                            </div>

                            <h6
                                style={{
                                    color: "#ffffffb3",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    letterSpacing: "2px",
                                    textAlign: "center",
                                }}
                            >
                                核心技术人才经验
                            </h6>
                        </Col>
                    </Row>
                </div>
            </main>
            <Footer data={{ ...data.site.siteMetadata }} />
        </Layout>
    );
};

export const query = graphql`
    query AboutPageQuery {
        allGeneral {
            nodes {
                section
                ...HeaderOne
            }
        }
        site {
            ...Site
        }
        page(
            title: { eq: "corporate-culture" }
            pageType: { eq: "innerpage" }
        ) {
            content {
                ...PageContent
            }
        }
        allItSolution(limit: 3) {
            nodes {
                ...ItSolutionThree
            }
        }
    }
`;

AboutPage.propTypes = {
    location: PropTypes.shape({}),
    data: PropTypes.shape({
        allGeneral: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        site: PropTypes.shape({
            siteMetadata: PropTypes.shape({
                contact: PropTypes.shape({}),
            }),
        }),
        page: PropTypes.shape({
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        allItSolution: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export default AboutPage;
